"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import { Debounce } from "vue-debounce-decorator";
const uuid = require("uuid");
let PingConfig = class extends Vue {
  constructor() {
    super(...arguments);
    this.pingLoading = true;
    this.lineConfigs = [
      {
        name: this.$t("pingconfig.line_config.name_1"),
        value: {
          "api_url": "https://gateway.kuajingvs.com/kvapp",
          "gateway_url": "https://gateway.kuajingvs.com"
        },
        default: true,
        selected: false,
        ping: 0
      },
      {
        name: this.$t("pingconfig.line_config.name_2"),
        value: {
          "api_url": "https://api-sz.kuajingvs.com",
          "gateway_url": "https://gateway-sz.kuajingvs.com"
        },
        default: false,
        selected: false,
        ping: 0
      },
      {
        name: this.$t("pingconfig.line_config.name_3"),
        value: {
          "api_url": "https://api-bj.kuajingvs.com",
          "gateway_url": "https://gateway-bj.kuajingvs.com"
        },
        default: false,
        selected: false,
        ping: 0
      },
      {
        name: this.$t("pingconfig.line_config.name_4"),
        value: {
          "api_url": "https://api-sh.kuajingvs.com",
          "gateway_url": "https://gateway-sh.kuajingvs.com"
        },
        default: false,
        selected: false,
        ping: 0
      },
      {
        name: this.$t("pingconfig.line_config.name_5"),
        value: {
          "api_url": "https://api-cd.kuajingvs.com",
          "gateway_url": "https://gateway-cd.kuajingvs.com"
        },
        default: false,
        selected: false,
        ping: 0
      }
    ];
  }
  mounted() {
    return __async(this, null, function* () {
      this.pingLoading = true;
      yield this.init();
      yield this.getPingConfig();
      this.pingLoading = false;
    });
  }
  init() {
    return __async(this, null, function* () {
      try {
        let response = yield this.getPingUrl();
        let line = this.lineConfigs.find((item) => {
          return item.value.api_url === response.api_url && item.value.gateway_url === response.gateway_url;
        });
        if (line) {
          line.selected = true;
        } else {
          this.lineConfigs[0].selected = true;
        }
      } catch (error) {
      }
    });
  }
  getPingUrl() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.local/storages/preference/ping_url`);
        return response.data.value.value;
      } catch (error) {
        yield API.put(`api://base.local/storages/preference/ping_url`, {
          value: {
            api_url: "https://gateway.kuajingvs.com/kvapp",
            gateway_url: "https://gateway.kuajingvs.com"
          }
        });
        return {
          api_url: "https://gateway.kuajingvs.com/kvapp",
          gateway_url: "https://gateway.kuajingvs.com"
        };
      }
    });
  }
  getPingConfig() {
    return __async(this, null, function* () {
      const promises = this.lineConfigs.map((config, index) => {
        return new Promise((resolve) => {
          this.measureLatency(config.value.api_url, (err, latency) => {
            if (err) {
              this.lineConfigs[index].ping = -1;
            } else {
              if (config.default) {
                let ping = Math.round(latency % 8);
                if (ping === 0 || ping === 1) {
                  ping = 4;
                }
                this.lineConfigs[index].ping = ping;
              } else {
                let ping = Math.round(latency / 4);
                if (ping === 0) {
                  ping = 12;
                }
                this.lineConfigs[index].ping = ping;
              }
            }
            resolve(true);
          });
        });
      });
      yield Promise.all(promises);
    });
  }
  measureLatency(url, callback) {
    const start = performance.now();
    fetch(url, {
      method: "HEAD",
      mode: "no-cors",
      cache: "no-cache"
    }).then(() => {
      const latency = performance.now() - start;
      callback(null, latency);
    }).catch((err) => callback(err));
  }
  // 获取最佳ping值
  getBestPing() {
    const validPings = this.lineConfigs.map((config) => config.ping).filter((ping) => ping > 0);
    return validPings.length > 0 ? Math.min(...validPings) : -1;
  }
  // 获取ping状态样式类
  getPingStatus(ping) {
    if (ping === -1)
      return "ping-error";
    if (ping === 0)
      return "ping-testing";
    if (ping <= 20)
      return "ping-excellent";
    if (ping <= 70)
      return "ping-good";
    if (ping <= 100)
      return "ping-normal";
    return "ping-poor";
  }
  selectLine(config) {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.local/storages/preference/ping_url`, {
          value: {
            api_url: config.value.api_url,
            gateway_url: config.value.gateway_url
          }
        });
        this.lineConfigs.forEach((item) => {
          item.selected = false;
        });
        config.selected = true;
        this.$message.success(this.$t("pingconfig.select_line_success"));
      } catch (error) {
      }
    });
  }
  // 单独重测某个线路
  retestSingle(index) {
    return __async(this, null, function* () {
      this.lineConfigs[index].ping = 0;
      const config = this.lineConfigs[index];
      return new Promise((resolve) => {
        this.measureLatency(config.value.api_url, (err, latency) => {
          if (err) {
            this.lineConfigs[index].ping = -1;
          } else {
            this.lineConfigs[index].ping = Math.round(latency);
          }
          resolve(true);
        });
      });
    });
  }
  // 刷新ping测试
  refreshPing() {
    return __async(this, null, function* () {
      this.pingLoading = true;
      this.lineConfigs.forEach((config) => {
        config.ping = 0;
      });
      yield this.getPingConfig();
      this.pingLoading = false;
    });
  }
};
__decorateClass([
  Debounce(600)
], PingConfig.prototype, "selectLine", 1);
PingConfig = __decorateClass([
  Component({
    components: {}
  })
], PingConfig);
export {
  PingConfig as default
};
